module.exports = __webpack_public_path__ + "static/media/playstore-brazil@3x.e2cae186.png";